import React from 'react';

const GallerySection = () => {
  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_6ecc521e-0167-467f-95d1-01468e73454b/artifacts/vuzdh89g_Imagem2.jpg',
      alt: 'Gizeli Rodrigues - Terapeuta'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_6ecc521e-0167-467f-95d1-01468e73454b/artifacts/3ds0s51w_Imagem3.jpg',
      alt: 'Gizeli Rodrigues - Atendimento'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_6ecc521e-0167-467f-95d1-01468e73454b/artifacts/13nus411_Imagem4.jpg',
      alt: 'Gizeli Rodrigues - Consultório'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6">
            {images.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="eager"
                    style={{ imageRendering: 'high-quality' }}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
